<template>
  <div class="px-4 py-2 border border-gray-300 rounded">
    <div class="flex justify-between">
      <div>
        <div class="text-lg">{{ product.Product }}</div>
        <div class="text-gray-500">{{ product.SKU }}</div>
      </div>
      <div class="flex flex-col justify-center">
        <span
          v-if="isShipped"
          class="px-2 bg-green-500 text-xs text-white rounded-full"
        >
          Shipped {{ this.dateFormat(product.DateShipped) }}
        </span>
        <div v-else class="flex justify-around items-center space-x-2">
          <v-date-picker
            v-model="newExpectedShipDate"
            color="green"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import dateFormatter from "@/mixins/dateFormatter";

export default {
  name: "OrderEditProductESD",
  components: {},
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  mixins: [dateFormatter],
  watch: {
    newExpectedShipDate: function (newDate) {
      this.updatedESD(newDate);
    }
  },
  data() {
    return {
      newExpectedShipDate: this.product.ExpectedShipDate
    };
  },
  computed: {
    isShipped() {
      if (this.product.DateShipped === null) {
        return false;
      }

      const today = new Date();
      const printTime = new Date(this.product.DateShipped);
      return today > printTime;
    },
  },
  methods: {
    dateFormat(dateString, options) {
      let date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        ...{ year: "numeric", month: "long", day: "numeric" },
        ...options
      });
    },
    updatedESD(newDate) {
      this.$emit('esd-updated', {
        ...this.product,
        newExpectedShipDate: dateFormatter.formatDateForStorage(newDate)
      });
    }
  }
};
</script>
